import styled from 'styled-components';

export const Subtitle = styled.p`
  font-size: var(--m-font-size);
  text-align: center;
  max-width: 312px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
  margin-top: 42px;
`;
